const shipmentDocumentTypeEnum = {
	packingSlip: 0,
	billOfLading: 1,
	upcLabel: 2,
	gs1Label: 3,
};

export { shipmentDocumentTypeEnum };
